var _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCashCode64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7774 7H22.3331C20.032 7 18.1665 8.86547 18.1665 11.1666V52.833C18.1665 55.1342 20.032 56.9996 22.3331 56.9996H41.7774C44.0786 56.9996 45.9441 55.1342 45.9441 52.833V11.1666C45.9441 8.86547 44.0786 7 41.7774 7Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7774 7H22.3331C20.032 7 18.1665 8.86547 18.1665 11.1666V52.833C18.1665 55.1342 20.032 56.9996 22.3331 56.9996H41.7774C44.0786 56.9996 45.9441 55.1342 45.9441 52.833V11.1666C45.9441 8.86547 44.0786 7 41.7774 7Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1665 49.8574H45.9441V52.8336C45.9441 55.1348 44.0786 57.0002 41.7774 57.0002H22.3331C20.032 57.0002 18.1665 55.1348 18.1665 52.8336V49.8574Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0557 55.214C33.0562 55.214 33.8673 54.4145 33.8673 53.4283C33.8673 52.4421 33.0562 51.6426 32.0557 51.6426C31.0552 51.6426 30.2441 52.4421 30.2441 53.4283C30.2441 54.4145 31.0552 55.214 32.0557 55.214Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15.333,
    width: 36.1108,
    height: 12.4999,
    rx: 2,
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3333,
    y: 33.3887,
    width: 19.4443,
    height: 9.72215,
    rx: 2,
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1665 18.1113L22.3331 24.3613",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 18.1113L18.1666 24.3613",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0693 18.1113L28.236 24.3613",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2358 18.1113L24.0692 24.3613",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9722 18.1113L34.1388 24.3613",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1389 18.1113L29.9723 24.3613",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.875 18.1113L40.0416 24.3613",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0415 18.1113L35.8749 24.3613",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7773 18.1113L45.944 24.3613",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9438 18.1113L41.7772 24.3613",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.571,
    cy: 38.2502,
    r: 1.38888,
    fill: "#1E1E1E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.1369,
    cy: 38.2502,
    r: 1.38888,
    fill: "#1E1E1E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.7028,
    cy: 38.2502,
    r: 1.38888,
    fill: "#1E1E1E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.2683,
    cy: 38.2502,
    r: 1.38888,
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCashCode64);
export default __webpack_public_path__ + "static/media/pictogramBeaconCashCode64.93ef6fa2cb00cc84991ec85367bb1594.svg";
export { ForwardRef as ReactComponent };